/** Placeholder palette; index = heat level 0…7. Replace with design tokens when ready. */
export const SCANNING_PEAK_HEATMAP_COLORS: string[] = [
  'var(--info-50)',
  'var(--info-100)',
  'var(--info-200)',
  'var(--info-300)',
  'var(--info-400)',
  'var(--info-500)',
  'var(--info-600)',
  'var(--info-700)',
];

/** Canonical hour keys (HH:mm) for grid columns; */
export const HEATMAP_HOUR_TIME_SLOTS: readonly string[] = Array.from(
  { length: 24 },
  (_, h) => `${String(h).padStart(2, '0')}:00`,
);
